import { apiGet, apiPost } from 'shared/services/api/resource';
import { MOCK_PARTICIPANTS } from 'modules/jogador/checkout/content';
import { Participant, PaymentMethod } from 'modules/jogador/checkout/types';

// Outros jogadores que já entraram na divisão da reserva (rachadinha), se splitEnabled.
export function fetchSplitParticipants(orderId: string): Promise<Participant[]> {
  return apiGet(MOCK_PARTICIPANTS, `/reservations/${orderId}/participants`);
}

export function payOrder(orderId: string, method: PaymentMethod) {
  return apiPost({ orderId, paid: true as const }, `/reservations/${orderId}/pay`, { method }, 400);
}
